import type { SVGProps } from 'react';
const SvgIconSettings = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16" {...props}>
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M4 .975a.75.75 0 0 1 .75.75V4h.5C6.216 4 7 4.783 7 5.75v3.5A1.75 1.75 0 0 1 5.25 11h-.5v3.275a.75.75 0 0 1-1.5 0V11h-.5A1.75 1.75 0 0 1 1 9.25v-3.5C1 4.783 1.784 4 2.75 4h.5V1.725A.75.75 0 0 1 4 .975M2.75 5.5a.25.25 0 0 0-.25.25v3.5c0 .138.112.25.25.25h2.5a.25.25 0 0 0 .25-.25v-3.5a.25.25 0 0 0-.25-.25zm10-3.775a.75.75 0 0 0-1.5 0V5h-.5A1.75 1.75 0 0 0 9 6.75v3.5c0 .966.784 1.75 1.75 1.75h.5v2.275a.75.75 0 0 0 1.5 0V12h.5A1.75 1.75 0 0 0 15 10.25v-3.5A1.75 1.75 0 0 0 13.25 5h-.5zM10.5 6.75a.25.25 0 0 1 .25-.25h2.5a.25.25 0 0 1 .25.25v3.5a.25.25 0 0 1-.25.25h-2.5a.25.25 0 0 1-.25-.25z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgIconSettings;
